import React, { useCallback, useContext } from 'react';
import { Space } from 'antd';
import * as Icons from '@ant-design/icons';
import { HeadPortal } from '@modules/layout/components/head-portal';
import { StyledHeaderButton } from '@modules/layout/styled';
import { StyledActionBar } from '@shared/styled/action-bar';
import { useBackgroundNavigate } from '@shared/hooks/use-background-navigate';
import { useAuth } from '@modules/me';
import { CashRegisterOperationsTableContext } from '../context';

export const CashRegisterOperationsActionBar = () => {
  const { state, handleFetch, handleReset, handleSelectAll, handleResetSelection } = useContext(CashRegisterOperationsTableContext);
  const { can } = useAuth();
  const navigate = useBackgroundNavigate();
  const selectionCount = Object.keys(state.selectedRowIds || {}).length;

  const openCreate = useCallback(() => {
    navigate('/cash-flow/operations/create', { withBackground: true });
  }, [navigate]);

  return (
    <HeadPortal>
      <StyledActionBar $flex={true}>
        <Space size={0}>
          <StyledHeaderButton type="text" disabled={!can('cash_categories.cud')} onClick={openCreate} icon={<Icons.PlusCircleOutlined />}>
            Yeni
          </StyledHeaderButton>
          {!selectionCount ? (
            <StyledHeaderButton type="text" onClick={handleSelectAll} icon={<Icons.CheckCircleOutlined />}>
              Hamısını seç
            </StyledHeaderButton>
          ) : (
            <StyledHeaderButton type="text" onClick={handleResetSelection} icon={<Icons.CloseCircleOutlined />}>
              {selectionCount} sətir seçilib
            </StyledHeaderButton>
          )}
          <StyledHeaderButton type="text" onClick={handleFetch} icon={<Icons.ReloadOutlined />}>
            Yenilə
          </StyledHeaderButton>
          <StyledHeaderButton type="text" onClick={handleReset} icon={<Icons.ClearOutlined />}>
            Sıfırla
          </StyledHeaderButton>
        </Space>
      </StyledActionBar>
    </HeadPortal>
  );
};
